<template>
    <div>
        <el-row style="display: flex;margin-bottom: 10px;">
            <el-col :span="4" v-if="theProjectId == 0">
                <el-select v-model="form.projectId" @change="theProjectAllChange" size="small" filterable clearable
                    placeholder="请选择项目">
                    <el-option v-for="item in getProjectList_data.data || []" :key="item.projectId"
                        :label="item.projectName" :value="item.projectId">
                    </el-option>
                </el-select>
            </el-col>
            <el-col>
                <el-button v-if="addBwTask"
                    @click="fileWordList = fileImgList = [], ybttrTimes_arr = [{ ybttrTime: '', ybttrId: '' }], $form('addBwTask')"
                    size='small' type="primary" style="float:right" icon='el-icon-circle-plus'>添加班务作业
                </el-button>
            </el-col>
        </el-row>
        <div>
            <myform :viewobj='{
                addBwTask: ["新增班务作业", "el-icon-circle-plus"],
                updateBwTask: ["修改班务作业", "el-icon-edit-outline"],
                $succeed$: getBwTaskList
            }' @confirm='myform'
                @close="$form('addBwTask', 'reset'); window.sleep(50, v => Myformdata && (Myformdata.ybtFileAudio = Myformdata.ybtFileVideo = '', fileWordList = fileImgList = [], ybttrTimes_arr = [{ ybttrTime: '', ybttrId: '' }]))">
                <hide slot='projectId' />
                <hide slot='ybtId' />
                <template v-slot:ybtFileImage="{ Myformdata }">
                    <my-upload ref="Imgupload" @fileChange="fileImgChange($event)" :filearr="fileImgList" :limit="99"
                        @removeAfter="removeAfterImg($event)" style="margin: 10px 5px 5px;">
                    </my-upload>
                </template>
                <template v-slot:ybtFileDocument="{ Myformdata }">
                    <my-upload ref="Imgupload" @fileChange="fileChange($event)" :filearr="fileWordList" :limit="99"
                        @removeAfter="removeAfter($event)" style="margin: 10px 5px 5px;" type="text">
                    </my-upload>
                </template>
                <template v-slot:ybtFileAudio="{ Myformdata }">
                    <myupload v-event.fileUpload='`
                      return (Myformdata.ybtFileAudio+"").startsWith("http") 
                || ( (C = (await C.MyUpload()).file) ? Myformdata.ybtFileAudio = C : false )
            `' @change='Myformdata.ybtFileAudio = ($file$ = arguments[0]).url'
                        @remove='window.sleep(150, v => Myformdata.ybtFileAudio = "")' type='video' :limit='1'
                        :params='{ file: "$file$" }' :filelist="Myformdata.ybtFileAudio && Myformdata.ybtFileAudio != ' '
                            ? ({ name: Myformdata.ybtFileAudio, url: Myformdata.ybtFileAudio })
                            : false
                            " videoStyle="max-height:300px;"
                        x:style="{height: $form('updateBwTask','ifshow') ? '250px' : ''}">
                    </myupload>
                </template>
                <template v-slot:ybtFileVideo="{ Myformdata }">
                    <myupload v-event.fileUpload='`
                      return (Myformdata.ybtFileVideo+"").startsWith("http") 
                || ( (C = (await C.MyUpload()).file) ? Myformdata.ybtFileVideo = C : false )
            `' @change='Myformdata.ybtFileVideo = ($file$ = arguments[0]).url'
                        @remove='window.sleep(150, v => Myformdata.ybtFileVideo = "")' type='video' :limit='1'
                        :params='{ file: "$file$" }' :filelist="Myformdata.ybtFileVideo && Myformdata.ybtFileVideo != ' '
                            ? ({ name: Myformdata.ybtFileVideo, url: Myformdata.ybtFileVideo })
                            : false
                            " videoStyle="max-height:300px;"
                        x:style="{height: $form('updateBwTask','ifshow') ? '250px' : ''}">
                    </myupload>
                </template>
                <template v-slot:ybtDateStart="{ Myformdata }">
                    <el-date-picker v-model="Myformdata.ybtDateStart" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择开始日期时间">
                    </el-date-picker>
                </template>
                <template v-slot:ybtDateEnd="{ Myformdata }">
                    <el-date-picker v-model="Myformdata.ybtDateEnd" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择结束日期时间">
                    </el-date-picker>
                </template>
                <template v-slot:ybttrTimes="{ Myformdata }">
                    <div v-for="(item, index) in ybttrTimes_arr" :key="index" style="margin: 20px 0;">
                        <el-button type="danger" icon="el-icon-remove" @click="timeDel(index)"></el-button>
                        <el-date-picker v-model="item.ybttrTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期时间">
                        </el-date-picker>
                        <el-button type="success" icon="el-icon-circle-plus" @click="timeAdd"></el-button>
                    </div>
                </template>
            </myform>
            <mytable :tableColums='tableColums_getBwTaskList' api='getBwTaskList'
                xupdateapi='updateOpportunityBusinessCheckImage' :height="H - 165">
                <div slot="ybtFileImage" slot-scope="{row}" style="max-height:30vh;overflow:auto;max-width:99%;"
                    class="fCenter">
                    <img :src="img" alt="" loading="lazy" v-for="img in (row.ybtFileImage.split(','))"
                        onclick="document.PreviewVideo(this.src)" :title="'点击预览 ' + img" :key="img" />
                </div>
                <div slot="ybtFileDocument" slot-scope="{row}" style="max-height:30vh;overflow:auto;max-width:99%;display: flex;align-items: center;justify-content: center;"
                    class="fCenter">
                    <el-button
                        v-for="(img, index) in (row.ybtFileDocument && row.ybtFileDocument != ' ' ? row.ybtFileDocument.split(',') || [] : [])"
                        :key="index" size="mini" type="text" style="color: deepskyblue;margin: 0 10px;"
                        @click="DocumentLook(img)">
                        文件{{ index + 1 }}</el-button>
                </div>
                <div slot="ybtFileAudio" slot-scope="{row}" style="max-height:30vh;overflow:auto;max-width:99%;"
                    class="fCenter">
                    <a v-if="row.ybtFileAudio && row.ybtFileAudio != ' '" :href="row.ybtFileAudio">预览</a>
                    <!-- <audio :src="row.ybtFileAudio" style="width: 100%;"></audio> -->
                </div>
                <div slot="ybtFileVideo" slot-scope="{row}" style="max-height:30vh;overflow:auto;max-width:99%;color: red;"
                    class="fCenter" @click="PreviewVideo2(row.ybtFileVideo)">
                    {{ row.ybtFileVideo && row.ybtFileVideo != ' ' ? '预览' : '' }}
                </div>
            </mytable>

            <myform view.lookUsers='作业提交状态' id='FormTop' top='20px' @close='$form("lookUsers", "hide")'>
                <div style="height: 40px;display: flex;align-items: center;">
                    <el-col :span="18">
                        <el-select v-model='bwtnStatus' @change="parsch()" size="small" clearable placeholder="请选择附件类型">
                            <el-option label="未提交" :value="1"></el-option>
                            <el-option label="已提交" :value="2"></el-option>
                        </el-select>
                    </el-col>
                    <el-col>
                        <el-button @click="toExportExcelSts" type="primary" icon='el-icon-search' size='small'
                            style='margin-left:10px;'>导出学员数据
                        </el-button>
                        <el-button @click="GZHsub" type="primary"  size='small'
                            style='margin-left:10px;'>作业提交提醒
                        </el-button>
                    </el-col>

                </div>
                <mytable ref="getUserVisitorListTable" :tableColums='tableColums_getBwTaskNoticeList' api='getBwTaskNoticeList::bwtnId'
                    xupdateapi='updateOpportunityBusinessCheckImage' :height="H - 165">
                </mytable>
            </myform>
        </div>
    </div>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
let Base64 = require("js-base64").Base64;
export default {
    data() {
        return {
            theId: '',
            baseUrl: $Api.baseUrl_online,
            isYbtShow: false,
            tableColums_getBwTaskNoticeList: {
                $selection: true,
                // oiType: '限制字段key',
                userName: '学员',
                bwtnStatus: ['状态', , '@v-if: 1:未提交#danger,2:已提交#success',],
                yusSubscribe: ['公众号关注状态', , '@v-if: 0:未关注#danger,1:已关注#success',],
            },

            ybttrTimes_arr: [{ ybttrTime: "", ybtrrId: '', }],
            fileWordList: [],
            fileImgList: [],
            theProjectId: 0,
            value: '',
            form: {
                projectId: '',
                yasDate: '',
                yasCommand: '',
                yasTimeStart: '',
                yasTimeEnd: '',
                yasDes: '',
            },
            tableColums_getBwTaskList: {
                $selection: false,

                // oiType: '限制字段key',
                ybtTitle: '作业标题',
                ybtDes: '作业描述',
                ybtFileImage: ['图片', 200],
                ybtFileDocument: ['文档', 200],
                ybtFileAudio: ['音频', 80],
                ybtFileVideo: ['视频', 80],
                ybtDateStart: '开始打卡时间',
                ybtDateEnd: '结束打卡时间',

                $operation: [
                    '操作', 150,
                    this.getBwTaskNoticeList && `@text: 作业状态#success
               @click: @click: $form( 'lookUsers', $this.row = $row ),getBwTaskNoticeList({ybtId:$row.ybtId}),theId = $row.ybtId
              `,
                    this.updateBwTask && `@text: 编辑#success
               @click:FormEdit($row)
              `,
                    this.deleteBwTask && `@text: 删除#danger
               @click: _confirm('确定要删除该填写项约束吗?')
                       .trigger('deleteBwTask',{ybtId:$row.ybtId})
                       .trigger('getBwTaskList',{projectId:form.projectId})
              `,
                ],
            }
        }
    },
    methods: {
        GZHsub(){
            console.log(this.$refs.getUserVisitorListTable);
            
            this.$confirm('确定要发送作业提交提醒吗?').then(() => {
                const selection = Object.keys(this.$refs.getUserVisitorListTable.$MyTableCache);
                console.log(selection);
                this.addBwTaskRemindRecordUser({ ybtId: this.theId, bwtnIds: selection ? selection.join(',') : '' }).result(res => {
                    this.$message({
                        message: "发送成功",
                        type: "success"
                    });
                    this.$refs.getUserVisitorListTable.$$clear$$();
                })
            }).catch(() => {});    
        },
        parsch() {
            this.getBwTaskNoticeList({
                ybtId: this.theId,
                bwtnStatus: this.bwtnStatus
            });
        },
        openLoading() {
            //loading请求等待
            this.loading = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        toExportExcelSts: async function () {
            const that = this;
            that.openLoading();
            axios({
                method: 'post',
                url: that.baseUrl + '/opportunity/bw-task-notice/exportIvJobApplicantList',
                data: '',
                withCredentials: true,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'token': A.local('$Usertoken'),
                    'projectId': +A.local('$projectId'),
                }
            }).then(function (response) {
                that.loading.close();
                let a = document.createElement('a');
                //ArrayBuffer 转为 Blob
                let blob = new Blob([response.data], { type: "application/vnd.ms-excel" });
                let objectUrl = URL.createObjectURL(blob);
                a.setAttribute("href", objectUrl);
                a.setAttribute("download", '学员提交状态.xlsx');
                a.click();
                that.$message({
                    message: "成功",
                    type: "success"
                });
            }).catch(function (error) {
                that.loading.close();
                console.log(error);
            });
        },
        async getBwTaskNoticeList_Click(row) {
            this.getBwTaskNoticeList({ ybtId: row.ybtId }).result(res => {
                if (res.data.data) {
                    this.ybtId = row.ybtId;
                    this.isYbtShow = true;
                }

                // this.getBwTaskNoticeList_data =res.data.data;
                // this.ybtId = row.ybtId;
                // this.isYbtShow = true;
            })
        },
        FormEdit(row) {
            this.getBwTaskDetails({ ybtId: row.ybtId }).result(res => {
                this.fileImgList = this.fileWordList = [];
                this.Myformdata = JSON.parse(JSON.stringify(res.data.data));
                this.Myformdata.ybtFileDocument = this.Myformdata.ybtFileDocument ? this.Myformdata.ybtFileDocument.split(',') : [];
                this.Myformdata.ybtFileImage = this.Myformdata.ybtFileImage ? this.Myformdata.ybtFileImage.split(',') : [];
                if (res.data.data.ybtFileDocument) {
                    if (res.data.data.ybtFileDocument.indexOf(',') != -1) {
                        res.data.data.ybtFileDocument.split(',').forEach((item, index) => {
                            const s = { name: item, url: item };
                            this.fileWordList.push(s);
                        })
                    } else {
                        this.fileWordList = [{ name: res.data.data.ybtFileDocument, url: res.data.data.ybtFileDocument }];
                    }
                }
                if (res.data.data.ybtFileImage) {
                    if (res.data.data.ybtFileImage.indexOf(',') != -1) {
                        res.data.data.ybtFileImage.split(',').forEach((item, index) => {
                            const s = { name: item, url: item };
                            this.fileImgList.push(s);
                        })
                    } else {
                        this.fileImgList = [{ name: res.data.data.ybtFileImage, url: res.data.data.ybtFileImage }];
                    }
                }
                this.ybttrTimes_arr = res.data.data.bwTaskRuleRemindList.length > 0 ? res.data.data.bwTaskRuleRemindList : [{ ybttrTime: '', ybtrrId: '' }];
                this.$form("updateBwTask", this.Myformdata)
            })

        },
        PreviewVideo2(url) {
            if (url) {
                document.PreviewVideo(url)
            }
        },
        DocumentLook(URL) {
            window.open(`https://filepreview.aojuai.com/onlinePreview?url=${encodeURIComponent(Base64.encode(URL))}`)
        },
        timeDel(index) {
            if (this.ybttrTimes_arr.length == 1) {
                return
            }
            this.ybttrTimes_arr.splice(index, 1)
        },
        timeAdd() {
            const s = { ybttrTime: '', ybtrrId: '', };
            this.ybttrTimes_arr.push(s)
        },
        fileChange(file) {
            console.log(file);
            if (this.Myformdata.ybtFileDocument.length > 0) {
                this.Myformdata.ybtFileDocument = this.Myformdata.ybtFileDocument.concat(file)
            } else {
                this.Myformdata.ybtFileDocument = file
            }
        },
        fileImgChange(file) {
            console.log(file);
            if (this.Myformdata.ybtFileImage.length > 0) {
                this.Myformdata.ybtFileImage = this.Myformdata.ybtFileImage.concat(file)
                console.log(this.Myformdata.ybtFileImage);
            } else {
                this.Myformdata.ybtFileImage = file
            }
        },
        removeAfter(file) {
            const url = this.Myformdata.ybtFileDocument.findIndex(item => item === file)
            this.Myformdata.ybtFileDocument.splice(url, 1);
        },
        removeAfterImg(file) {
            const url = this.Myformdata.ybtFileImage.findIndex(item => item === file)
            this.Myformdata.ybtFileImage.splice(url, 1);
        },
        async myform(submit, Myformdata) {
            const res = await this.$trigger("fileUpload").trigger(res => res && this.sub(submit))
        },
        async sub(submit) {
            console.log(this.Myformdata, this.deatilObj);
            this.Myformdata.ybtFileImage = this.Myformdata.ybtFileImage ? this.Myformdata.ybtFileImage.toString() : null;
            this.Myformdata.ybtFileDocument = this.Myformdata.ybtFileDocument ? this.Myformdata.ybtFileDocument.toString() : null;
            this.Myformdata.ybttrTimes = this.ybttrTimes_arr[0].ybttrTime ? JSON.stringify(this.ybttrTimes_arr) : [];
            this.$nextTick(() => {

            })
            submit();
        },
        theProjectAllChange(e) {
            if (e == '') {
                return this.form.projectId = e;
            }
            this.form.projectId = e;
            this.getBwTaskList({ projectId: this.form.projectId })
        },
    },
    created() {
        this.getProjectList({
            pageSize: 0
        });

        this.theProjectId = A.local("$projectId");
        if (this.theProjectId != 0) {
            this.form.projectId = this.theProjectId;
        }
        this.getBwTaskList({ projectId: this.form.projectId })
    },
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/views/ClassManagement/ClassTest.vue